<template>
  <div>

    <Head @search='search'
          style="backgroundColor:#fff;" :keyword=searchTitle></Head>
    <navigationbar></navigationbar>
    <div class="firstdiv"></div>
    <div class="content flex flex-direction align-center">

      <div class="flex flex-direction width "
           style="height: auto;  ">
        <div
             style=" margin-top: 0.3rem "
             class="top flex flex-direction">

          <div class="flex classify align-center font-size-42"
               style=" height: 1.2rem;">

            <p class=" font-color-23c"
               style="margin-left:0.22rem;margin-right:0.22rem">"{{searchTitle}}"</p>
            <p class=" font-color-00">的搜索结果</p>
          </div>
          <div class="flex flex-wrap last align-center font-size-24">
            <p @click="fourCheck(index)"
               class="choose cursor-pointer"
               :class="index == fourIndex?'check':'uncheck'"
               v-for="(item, index) in fourClassify"
               :key="index">
              {{item.CatalogName}}
            </p>
          </div>
        </div>

        <div class="bottom  flex flex-direction " v-if="length==0 && loading == false">
         
          <div class="empty font-color-94 flex flex-direction  align-center font-size-36">
            <img style="width: 3.66rem; heigh: 3.32rem"
                 src="../../assets/pserson/empty.png" />
            很遗憾！没有找到相关课程~
          </div>
          <div>
            <p class=" font-color-ff font-size-30 bg-color-ffcb noempty">猜你感兴趣的课程</p>
            <div class="itemdiv"
                 style=" margin-bottom:.5rem">
              <courseItem v-for="(item, index) in recommendList"
                          :key="index"
                          :item="item"
                          style="margin-top: 0.36rem; margin-left: 0.26rem">
              </courseItem>

            </div>
          </div>
        </div>
        <div v-else
             class="bottom  flex flex-direction ">
         <div v-if="loading" class="loading flex justify-center" style="min-height: 9.82rem; margin-top: 1rem; background: #fff;">
            <span class="size bg-color-23"></span>
            <span class="size bg-color-23"></span>
            <span class="size bg-color-23"></span>
          </div>
          <div v-else>
             <div class="itemdiv">
            <courseItem v-for="(item, index) in dataList"
                        :key="index"
                        :item="item"
                        style="margin-top: 0.36rem; margin-left: 0.26rem">
            </courseItem>

          </div>

          <div style="margin: 0.5rem auto; display: flex; justify-content: center; ">

            <paginate v-if="totalPage>0"
                      :pages="totalPage"
                      @jump="jumpPage"
                      :groups="totalPage>5?5:totalPage"></paginate>
          </div>

        </div>
          </div>
        
      </div>
      <!-- <div class="seconddiv"></div> -->
    </div>

  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  data () {
    return {
      loading: false,
      totalPage: 0,
      fourIndex: 0,
      searchTitle: '',
      item: {
        Id: 0,
        CatalogName: "首页",
        ParentId: 0,
        Level: 1,
        Order: 1
      },
      recommendList: [],
      PageIndex: 1,
      fourClassify: [],
      dataList: [],
    };
  },
  computed: {
    length () {
      return this.dataList.length;
    },

  },

  beforeUpdate () {
    console.log(this.$route.params.search);
  },

  mounted () {
    console.log(this.$route.params.search);
  },

  created () {
    this.searchTitle = this.$route.params.search || "儿童";
    var list = [{
      Id: 0,
      CatalogName: "全部",
      ParentId: 0,
      Level: 1,
      Order: 1
    }];

    const cates = common.cate_fr.filter(v=> v.CatalogType == 1)
    console.log(cates)

    this.fourClassify = list.concat(cates);
    this.searchRequest()
    this.getSearchRecommendList();
  },

  methods: {

    searchRequest () {
      this.loading = true
      let params = {
        CatalogId: this.fourClassify[this.fourIndex].Id,
        KeyWord: this.searchTitle,
        PageIndex: this.PageIndex,
        PageSize: 16
      }
      this.getRequest('api/v1/Search', params).then(data => {
        if (data.IsSuccess) {
          this.totalPage = data.Data.TotalPage
          this.dataList = data.Data.List
        }
        this.loading = false
      }).catch((_)=>{
        this.loading = false
      })
    },
    getSearchRecommendList () {
      var that = this
      let params = {
        Limit: 8
      }
      this.getRequest('api/v1/Course/GetSearchRecommendList', params).then(data => {
        if (data.IsSuccess) {

          this.recommendList = data.Data
        }
      })
    },
    jumpPage (page) {
      this.PageIndex = page
      this.searchRequest();
    },
    search (keyTitle) {

      this.searchTitle = keyTitle;
      console.log(this.searchTitle);
      this.PageIndex = 1
       this.fourIndex = 0;
        this.PageIndex = 1;
      this.searchRequest()
    },


    thirdCheck (index) {
      if (this.thirdIndex != index) {
        this.thirdIndex = index;
      }
    },
    fourCheck (index) {
      if (this.fourIndex != index) {
        this.fourIndex = index;
        this.PageIndex = 1;
        this.searchRequest();
      }
    },

  },
};
</script>

<style scoped>
.firstdiv {
  background: url("../../assets/icon-bg.jpg");
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  /* background-size: 100% auto; */
  padding-bottom: 0.2rem;
  position: fixed;
  /* height: 5.05rem; */
  top: 0;
  left: 0;
  z-index: -1;
  background-color: #cbfeee;
}

.content {
  padding-bottom: 0.56rem;
}

.top {
  z-index: 3;
  min-height: 1.86rem;
  padding: 0 0.44rem;
  background: #ffffff;
  box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
  border-radius: 0.16rem;
}
.top .classify {
  padding: 0.24rem 0;
  border-bottom: 1px solid rgba(211, 211, 211, 0.5);
  height: 0.93rem;
}
.top .last {
  min-height: 0.93rem;
  padding: 0.2rem 0;
}
.choose {
  height: 0.45rem;
  line-height: 0.45rem;
  min-width: 1.2rem;
  padding: 0 0.2rem;
  margin: 0.1rem 0;
  text-align: center;
  white-space: nowrap;
  border-radius: 0.25rem;
}
.choose:hover {
  color: #ffffff;
  background: #ffcb05;
}

.check {
  color: #ffffff;
  background: #ffcb05;
}
.uncheck {
  color: #1b1b1b;
  background: #ffffff;
}

.bottom {
  width: 100%;
  margin-top: 0.34rem;
  z-index: 3;
  background: #ffffff;
  box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
  border-radius: 0.16rem;
}
.bottom .itemdiv {
  flex-wrap: wrap;
  display: flex;
  flex-grow: 1;

  align-content: flex-start;
}
.empty {
  width: 100%;

  margin-top: 0.6rem;
  margin-bottom: 0.44rem;
}

.empty p {
  margin-top: 0.4rem;
  width: 3.27rem;
  height: 0.67rem;
  background: #ffcb05;
  border-radius: 0.34rem;
  text-align: center;
  line-height: 0.67rem;
}

.empty p img {
  width: 0.13rem;
  height: 0.22rem;
}
.noempty {
  height: 0.77rem;
  width: auto;
  margin-left: 0.4rem;
  width: 3.07rem;
  border-radius: 0.4rem;
  padding: 0.1rem 0.3rem;
  box-sizing: border-box;
  line-height: 0.57rem;
}
</style>



// WEBPACK FOOTER //
// src/view/search/search.vue